import { call, get, put, select } from "redux-saga/effects";
import * as notificationAction from "../actions/notification";
import * as notificationSelector from "../selectors/notification";
import api from "../services/httpUtilities/httpService";
import httpErrorHelpers from "../services/httpUtilities/httpErrorHelpers";

function* watcherGetNotificationRequest() {
  try {
    const response = yield call(api.getNotification);
    const { items } = response.data;

    if (response.status === 200) {
      yield put(notificationAction.getNotificationSuccess(items));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      notificationAction.getNotificationFailure
    );
  }
}

function* watcherUpdateNotificationRequest({ id }) {
  try {
    const response = yield call(api.updateNotification, id);
    const { success, items } = response.data;

    if (success) {
      yield put(notificationAction.updateNotificationSuccess(items));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      notificationAction.updateNotificationFailure
    );
  }
}

function* watcherUpdateNotificationItemsIDRequest() {
  try {
    const itemsID = yield select(state =>
      notificationSelector.getNotificationItemsID(state.notification)
    );
    const response = yield call(api.updateNotificationItemsID, itemsID);
    const { success } = response.data;

    if (success) {
      yield put(notificationAction.updateNotificationItemsIDSuccess());
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      notificationAction.updateNotificationItemsIDFailure
    );
  }
}

export {
  watcherGetNotificationRequest,
  watcherUpdateNotificationRequest,
  watcherUpdateNotificationItemsIDRequest
};



// WEBPACK FOOTER //
// ./src/sagas/notification.js